import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function DeploymentIcon(props) {
    return <SvgIcon {...props}>
        <mask maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24"/>
        </mask>
        <g>
            <path
                d="M11 21V19H13V21H11ZM11 5V3H13V5H11ZM15 21V19H17V21H15ZM15 5V3H17V5H15ZM19 21V19H21V21H19ZM19 5V3H21V5H19ZM17 16L15.6 14.6L17.175 13H11V11H17.175L15.6 9.4L17 8L21 12L17 16ZM5 19H7V5H5V19ZM3 21V3H9V21H3Z"/>
        </g>
    </SvgIcon>

}
